import { Call } from "../../api/models/Call"
import { ADD_CALL, ADD_INCOMMING_CALL, ADD_USER, REMOVE_CALL, REMOVE_INCOMMING_CALL, REMOVE_USER, SET_USERS } from "../actionTypes"

export const setUsers = (users: string[]) => {
    return {
        type: SET_USERS,
        users
    }
}

export const addUser = (user: string) => {
    return {
        type: ADD_USER,
        user
    }
}

export const removeUser = (user: string) => {
    return {
        type: REMOVE_USER,
        user
    }
}

export const addIncommingCall = (incommingCall: Call) => {
    return {
        type: ADD_INCOMMING_CALL,
        incommingCall
    }
}

export const removeIncommingCall = () => {
    return {
        type: REMOVE_INCOMMING_CALL
    }
}

export const addCall = (call: Call) => {
    return {
        type: ADD_CALL,
        call
    }
}

export const removeCall = () => {
    return {
        type: REMOVE_CALL
    }
}